// cSpell:ignore afgerekend Deels vertrek
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { Lozenge, Tooltip } from "@rentiohq/web-shared/dist/components";
import React from "react";
import {
  departureShareLabel,
  ICostDepartureShare,
} from "../costSettlementState.utils";

// A cost that departure settlements settled part of: "Deels afgerekend
// (vertrek)", and in its tooltip each departure's tenant and last day (Lewis,
// 2026-10-21: the lines under it made the period cell too busy). The rest of
// the cost is still to settle, hence the "to settle" color. The costs list
// shows the same lozenge and tooltip.
export const DepartureShareStatus: React.FC<{
  shares: ICostDepartureShare[];
}> = ({ shares }) => (
  <Tooltip tooltipContent={shares.map(departureShareLabel).join(" · ")}>
    <span>
      <Lozenge appearance="warning">
        {getLocalizedText("costs.status.partly_settled_departure")}
      </Lozenge>
    </span>
  </Tooltip>
);
